import React, { useState } from "react";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import CommentForm from "../Blog/CommentForm";

const Comment = props => {
  const [replyOpen, setReplyOpen] = useState(false);
  const closeReply = () => setReplyOpen(false);
  return (
    <>
      <Row>
        <Card>
          <Card.Body>
            <Row>
              <Col
                style={{
                  fontSize: "12px",
                  color: "#a8a8b3",
                  padding: "5px 0",
                }}>
                <span>{props.data.fullname}</span>
                <span> ({props.data.created_at.ago_str})</span>
              </Col>
            </Row>
            <hr></hr>
            <Row>
              <Col>
                <p>{props.data.body}</p>
              </Col>
            </Row>
            <Row className="justify-content-end">
              {props.dpt <= 0 ? (
                <Button onClick={() => setReplyOpen(true)}>پاسخ</Button>
              ) : (
                ""
              )}
            </Row>
            <Modal show={replyOpen} onHide={closeReply} dir="rtl">
              <Modal.Header closeButton>
                <Modal.Title>پاسخ به دیدگاه</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <CommentForm
                  form_title=" پاسخ"
                  comment_id={props.data.id}
                  post_id={props.post_id}
                  modalClose={() => {
                    closeReply();
                    if (props.modalClose) props.modalClose();
                  }}
                />
              </Modal.Body>
            </Modal>
          </Card.Body>
        </Card>
      </Row>
      <Row style={{ paddingRight: "10%", marginTop: 10 }}>
        <Col style={{ paddingLeft: 0 }}>
          {(props.data.replies || []).map(comment => (
            <Comment
              key={comment.id}
              data={comment}
              dpt={props.dpt + 1}
              post_id={props.post_id}
              modalClose={props.modalClose}
            />
          ))}
        </Col>
      </Row>
    </>
  );
};

export default Comment;
